import {ILocation} from "data/entities/ILocation";
import {Transport} from "data/transport";

// declare var $:any;

export const DATAGetLocations = () => new Promise((resolve, reject) => {
  Transport.GET('/locations')
    .then((locations: ILocation[]) => {
      resolve(locations ? locations : []);
    })
    .catch((reason) => {
      console.log(reason);
      reject();
    });
});


export const DATAActivateAccount = (email:string, password:string):Promise<unknown> => Transport.POST('/activateAccount', {email:email, password: password});

// function(email, password, callback) {
//   $.ajax({
//     contentType:"application/json; charset=utf-8",
//     type:'POST',
//     url: URL("/activateAccount"),
//     data:JSON.stringify({email:email, password: password})
//   })
//     .done((response) => {
//       callback();
//     })
//     .fail((jqXHR, textStatus, errorThrown )=>{
//       callback(errorThrown);
//     });
// };


export const DATAResetPassword = (email:string, password:string):Promise<unknown> => Transport.POST('/passwordReset', {email:email, password: password});

// function(email, password, callback) {
//   $.ajax({
//     contentType:"application/json; charset=utf-8",
//     type:'POST',
//     url: URL("/passwordReset"),
//     data:JSON.stringify({email:email, password: password})
//   })
//   .done((response) => {
//     callback();
//   })
//   .fail((jqXHR, textStatus, errorThrown )=>{
//     callback(errorThrown);
//   });
// };

